export const getWordBasedOnCount = (word: string, count: number): string => {
	let wordBasedOnCount = word

	if (count !== 1) {
		wordBasedOnCount += "s"
	}

	return wordBasedOnCount
}
